import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFlowKey } from '../routing/getFlowKey';
import { Data } from 'signup-constants/signupData/Data';
import { getCurrentStep } from '../store/flow/selectors';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const getStepTitle = state => {
  const currentStep = getCurrentStep(state);
  const industry = getSignupDataValue(state, Data.Industry);
  const isAssignedToACQ143Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  const titleWithData = `views.${currentStep}.title-${Data.Industry}.${industry}`;
  const flowKey = getFlowKey();
  const experimentTitle = `views.${currentStep}.title.acq143`;
  const flowTitle = `views.${currentStep}.title.${flowKey}`;
  const defaultTitle = `views.${currentStep}.title.default`;
  let title = isValidI18nKey(flowTitle) ? flowTitle : defaultTitle;
  if (isAssignedToACQ143Variant && isValidI18nKey(experimentTitle)) {
    title = experimentTitle;
  }
  return isValidI18nKey(titleWithData) ? titleWithData : title;
};